import React, { useState } from 'react'
import Nav from '../../common/layout/nav'
import { Row, Col } from 'react-bootstrap'
import { prettifyNumber } from '../../../utility/prettifynumber'

// TODO: Bar charting plugin
function Dashboard() {
  const [userFirstName] = useState('Jun')
  const [totalSavings] = useState(12000.0)
  const [aprValue] = useState(7.2)
  const [monthlyBudget] = useState(3000.0)
  const [valueToSpend] = useState(1000.0)
  const [valueSpent] = useState(1750.0)
  const [valueToSave] = useState(250.0)

  return (
    <>
      <Row>
        <Col lg={2}>
          <Nav />
        </Col>
        <Col lg={7} className="pt-5 mx-auto">
          <Row>
            <h3>Hi {userFirstName}!</h3>
          </Row>
          <Row lg={1} className="migrant-box-container mb-5">
            <Col lg={7} className="mx-auto pt-3">
              <h1 className="font-black mx-auto">
                SGD {prettifyNumber(totalSavings)}
              </h1>
            </Col>
            <Row className="mx-auto pb-3">
              <Col lg={3} className="mx-auto migrant-box-container mt-3 mb-3">
                <h5 className="font-purple mx-auto">
                  earning {prettifyNumber(aprValue)}% APR
                </h5>
              </Col>
            </Row>
          </Row>
          <Row>
            <h3>Monthly budget</h3>
          </Row>
          <Row lg={1} className="migrant-box-container">
            <Row>
              <Col lg={7} className="mx-auto pt-3">
                <p className="font-purple">
                  <b>Monthly budget</b>
                </p>
                <p>
                  <b className="font-black mx-auto">
                    SGD {prettifyNumber(monthlyBudget)}
                  </b>
                </p>
              </Col>
            </Row>
            <Row className="mx-auto">
              <Col lg={7} className="mx-auto">
                <h1>============</h1>
              </Col>
            </Row>
            <Row lg={3} noGutters={true} className="mx-auto">
              <Col lg={3} className="mx-auto">
                <Row noGutters={true} className="">
                  <p className="font-purple mx-auto">
                    <b>You can spend</b>
                  </p>
                </Row>
                <Row noGutters={true} className="migrant-dashboard-top">
                  <p className="font-black mx-auto pt-3 mb-4">
                    <b>SGD {prettifyNumber(valueToSpend)}</b>
                  </p>
                </Row>
              </Col>
              <Col lg={6} className="mx-auto">
                {' '}
                <Row noGutters={true}>
                  <p className="font-purple mx-auto">
                    <b>You've spent</b>
                  </p>
                </Row>
                <Row noGutters={true} className="migrant-dashboard-middle">
                  <p className="font-teal mx-auto pt-3">
                    <b>SGD {prettifyNumber(valueSpent)} </b>
                  </p>
                </Row>
              </Col>
              <Col lg={3} className="mx-auto">
                {' '}
                <Row noGutters={true}>
                  <p className="font-purple mx-auto">
                    <b>You wanna save</b>
                  </p>
                </Row>
                <Row noGutters={true} className="migrant-dashboard-top">
                  <p className="font-black mx-auto pt-3">
                    <b>SGD {prettifyNumber(valueToSave)} </b>
                  </p>
                </Row>
              </Col>
            </Row>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default Dashboard
